<template>
  <span
    class="ui_radio"
    :class="{ on: !!value, disabled, readonly, filled }"
    @click="onClick">
    <i class="icon icon--radio"></i>
    <span class="text"><slot/></span>
  </span>
</template>

<script>
export default {
  name: 'UiRadio',
  props: [
    'value',
    'labelText',
    'disabled',
    'readonly',
    'filled'
  ],
  methods: {
    onClick (value) {
      if (!this.disabled) {
        this.$emit('input', !this.value)
      }
    }
  }
}
</script>

<style lang="scss">
.ui_radio {
  position: relative;
  cursor: pointer;
  transition: opacity 0.2s ease;

  .icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .bubble.top {
    top: 17px !important;
    margin-left: 7px !important;
  }

  .bubble.bottom {
    bottom: 17px !important;
    margin-left: 7px !important;
  }

  &:nth-last-of-type(1) {
    margin-left: 18px;
  }
  .text {
    font-size: 14px;
    color: #2f2f2f;
    margin-left: 25px;
  }

  &.disabled {
    // opacity: 0.3;
    pointer-events: none;
    .text {
      color: #bbb !important;
    }
  }

  &.readonly {
    pointer-events: none;
  }
}
</style>
